import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-top: 16px;
  `,
  card: css`
    height: ${pxToRem(24)};
    margin: 5px;
    padding: 4px 8px;
    gap: 8px;
    display: flex;
    align-items: center;
    background: rgba(230, 230, 230, 0.66);
    border-radius: ${pxToRem(10)};
    cursor: pointer;
    &:first-child {
      margin-left: 0;
    }
    @media only screen and (max-width: 480px) {
      max-width: ${pxToRem(130)};
      width: auto;
    }
  `,
  text: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  textDisabled: css`
    color: ${colors.slate};
  `,
};

export default styles;
